module.exports = __webpack_public_path__ + "img/f7f7b89.jpg";